import { IsDateString, IsEnum, IsNotEmpty, IsOptional, IsString, Matches } from 'class-validator';
import { Genders } from '../../administrative';
import { PERSON_NAME_REGEX, PERSON_NAME_REGEX_MESSAGE } from '../users/user-identity.dto';

export class UserRegistrationIdentityDto {
  @IsString()
  @IsNotEmpty()
  @Matches(PERSON_NAME_REGEX, {
    message: PERSON_NAME_REGEX_MESSAGE,
  })
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  @Matches(PERSON_NAME_REGEX, {
    message: PERSON_NAME_REGEX_MESSAGE,
  })
  lastName!: string;

  @IsDateString()
  @IsOptional()
  birthDate?: string;

  @IsEnum(Genders)
  @IsOptional()
  gender?: Genders;
}
